import React from 'react';
import Typography from '@mui/material/Typography';

const BiteListColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Name of Entity
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Entity Country
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Date Added
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Trade Domain
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Additional Remarks
        </Typography>
      </div>
    </>
  );
};

export default BiteListColumns;
